import React from 'react'

import StudentFormTakeQuestionsComponent from '../components/student-form-take-questions.component'

function StudentFormTakeQuestionsContainer() {
  return <StudentFormTakeQuestionsComponent />
}

export default StudentFormTakeQuestionsContainer
